import * as React from "react"
import type { SVGProps } from "react"
const SvgAlertTriangle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M2.73 20a1 1 0 0 1-.85-.5 1 1 0 0 1-.14-.49 1 1 0 0 1 .14-.51l9.24-16q.15-.26.4-.37Q11.74 2 12 2a1 1 0 0 1 .88.5l9.24 16q.15.25.14.51 0 .27-.14.49a1 1 0 0 1-.85.5zm1.72-2h15.1L12 5zM12 17q.42 0 .71-.29.3-.29.29-.71 0-.42-.29-.71A1 1 0 0 0 12 15q-.42 0-.71.29-.3.29-.29.71 0 .42.29.71.29.3.71.29m0-3q.42 0 .71-.29.3-.29.29-.71v-3q0-.42-.29-.71A1 1 0 0 0 12 9q-.42 0-.71.29-.3.29-.29.71v3q0 .42.29.71.29.3.71.29" />
  </svg>
)
export default SvgAlertTriangle
